import styled from 'styled-components';
// import boxShadow from '../../configs/boxShadow';
// import color from '../../configs/color';

const Wrapper = styled.div`
  .ant-col.ant-col-4 {
    .anticon {
      margin-top: 10px;
    }
  }
`;

export default Wrapper;
